// This file based on BE ExceptionCode.java
// https://bitbucket.org/accelaero/aero-suite-user-service/src/master/src/main/java/com/accelaero/aerosuite/user/constants/ExceptionCode.java
const GRPC_USER = {
  OK: {},
  CANCELLED: {},

  UNKNOWN: {
    GENERAL: 'USC-100' // Unexpected error.
  },

  INVALID_ARGUMENT: {
    ID                                       : 'USC-VLD-305',   // User id is not found.
    FIRST_NAME                               : 'USC-VLD-306',   // Invalid first name
    LAST_NAME                                : 'USC-VLD-307',   // Invalid last name
    JOB_TITLE                                : 'USC-VLD-308',   // Invalid job title
    EMPLOYER_NUMBER                          : 'USC-VLD-309',   // Invalid employer number
    GENERAL                                  : 'USC-VLD-311',   // Invalid argument.
    EMAIL                                    : 'USC-VLD-312',   // Invalid email.
    NAME_OR_PASS                             : 'USC-VLD-313',   // Invalid user name or password.
    DATE_TIME                                : 'USC-VLD-314',   // Invalid datetime format
    PHONE                                    : 'USC-VLD-315',   // Invalid phone number format
    USER_LINK                                : 'USC-VLD-316',   // Invalid user link
    DATETIME_AFTER_NOW                       : 'USC-VLD-317',   // Datetime is after now
    EXPIRED_LINK                             : 'USC-LNK-318',   // Link has been expired
    PASS_CAPITAL                             : 'USC-PWD-319',   // Incorrect password: capital letters missed
    PASS_NUMBER                              : 'USC-PWD-320',   // Incorrect password: numbers missed
    PASS_SYMBOL                              : 'USC-PWD-321',   // Incorrect password: special characters missed
    PASS_LENGTH                              : 'USC-PWD-322',   // Incorrect password: length less then 8 characters
    REASON                                   : 'USC-VLD-323',   // User Deletion reason: is empty
    NEW_PASS                                 : "USC-PWD-324",   // Incorrect password: new password is the same as old
    CURRENT_PASS                             : "USC-PWD-325",   // Incorrect password: old password not valid
    EXT_USER_NOT_ASSIGNED_TO_ANY_ORGANIZATION: 'USC-VLD-315',   // External user is not assigned to any organization
    USER_DOESNT_EXISTS                       : 'USC-USR-301',   // User does not exist
    NOT_AUTHORIZED                           : 'USC-ATH-314'    // User is not authorized, can not perform the action
  },

  DEADLINE_EXCEEDED: {},

  NOT_FOUND: {
    USER     : 'USC-USR-306',   // User does not exist.
    USER_LINK: 'USC-USR-307'    // User link does not exist.
  },

  ALREADY_EXISTS: {
    GENERAL: 'USC-USR-304' // User already exists.
  },

  PERMISSION_DENIED: {},
  UNAUTHENTICATED: {},
  RESOURCE_EXHAUSTED: {},

  FAILED_PRECONDITION: {
    EMAIL: 'USC-USR-302', // User mail should me email.
    REQUIRED_FIELDS: 'USC-USR-303', // User has empty mandatory field
    USER_STATUS_IVALID: 'USC-USR-308' // Existing user status is invalid.
  },

  ABORTED: {
    ALREADY_INVITED: 'USC-INV-301', // User already invited
    WRONG_USER_ID: 'USC-USR-307' // User id mismatch.
  },

  OUT_OF_RANGE: {},
  UNIMPLEMENTED: {},

  INTERNAL_ERROR: {
    SERVICE: 'USC-SSE-371', // Service setup error
    UNKNOWN: 'USC-NFS-372' // no description on BE
  },

  UNAVAILABLE: {},
  DATA_LOSS: {},

  UNLOCK: {
    EMPTY_ID: 'USC-VLD-336', // Unlock reason id can not be empty
    REASON_NOT_FOUND: 'USC-VLD-337', // Unlock reason with specified id is not found
    USER_NOT_FOUND: 'USC-USR-306', // User does not exist
    INVALID_STATUS: 'USC-USR-308', // Existing user status is invalid
    NO_EMAIL: 'USC-USR-311', // Can't reset password for user without email.
  }
};

export default GRPC_USER;
